import { c as _c } from "react/compiler-runtime";
import { Link as LinkIcon } from '@byway/icons';
import clsx from 'clsx';
import { Link } from '~/components/Link';
import styles from './LinkList.module.css';
type LinkListItem = {
  url: string;
  title: string;
};
type LinkListProps = {
  items: LinkListItem[];
  bordered?: boolean;
  capitalized?: boolean;
};
const LinkList = t0 => {
  const $ = _c(12);
  const {
    items,
    bordered: t1,
    capitalized: t2
  } = t0;
  const bordered = t1 === undefined ? false : t1;
  const capitalized = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== bordered) {
    t3 = clsx(styles.list, {
      [styles.bordered]: bordered
    });
    $[0] = bordered;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== bordered || $[3] !== capitalized || $[4] !== items) {
    let t5;
    if ($[6] !== bordered || $[7] !== capitalized) {
      t5 = t6 => {
        const {
          url,
          title
        } = t6;
        return <li key={`${url}-${title}`} className={clsx(styles.item, {
          [styles.itemBordered]: bordered,
          [styles.capitalized]: capitalized
        })}><Link href={url} isExternal={true} hasUnderline={true}><span className={styles.linkGroup}><LinkIcon decorative={true} size="large" /><span>{title}</span></span></Link></li>;
      };
      $[6] = bordered;
      $[7] = capitalized;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = items.map(t5);
    $[2] = bordered;
    $[3] = capitalized;
    $[4] = items;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <ul className={t3}>{t4}</ul>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export { LinkList };